import { render, staticRenderFns } from "./BizMultiSelect.vue?vue&type=template&id=23949f45&"
import script from "./BizMultiSelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./BizMultiSelect.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports